import { GridFilter } from "./GridFilter";
import { ToolFilter } from "./ToolFilter";

export class ExcelExport {
  constructor(
    public language: string,
    public filters: ToolFilter | GridFilter,
    public fields: ExcelExportColumn[],
  ) {}
}

export class ExcelExportColumn {
  constructor(
    public field: string,
    public label: string,
  ) {}
}

export enum ExcelExportType {
  Tools,
  FieldService,
  Contract,
  ContractTools,
}
